class RoundMapCtrl
  constructor: (@$scope, @GoogleMapLoaderService) ->
    @GoogleMapLoaderService.load().then =>
      @mapOptions =
        center: new google.maps.LatLng(@$scope.$parent.roundInfo.club.loc[0], @$scope.$parent.roundInfo.club.loc[1])
        zoom: 15
        mapTypeId: google.maps.MapTypeId.SATELLITE

RoundMapCtrl.$inject = [
  '$scope'
  'GoogleMapLoaderService'
]

module.exports = RoundMapCtrl


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-map/round-map-controller.coffee